import { extendTheme } from '@chakra-ui/react';

const chakraTheme = extendTheme({
  fonts: {
    body: 'var(--desco-font)',
  },
  styles: {
    global: (props) => ({
      body: {
        color: 'var(--white)',
        margin: 0,
      },
      a: {
        color: props.colorMode === 'dark' ? 'teal.300' : 'teal.500',
      },
    }),
  },
});

export default chakraTheme;
